var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "interface-area" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _c("ConfirmSwap", {
                  ref: "confirmSwap",
                  attrs: {
                    swap: _vm.swap,
                    "pair-data": _vm.pairData,
                    "input-method": _vm.inputMethod,
                    transaction: _vm.transaction,
                  },
                  on: {
                    swapTokens: _vm.swapTokens,
                    initConfirmState: function ($event) {
                      return _vm.changeModalTitle("init")
                    },
                    initLoading: function ($event) {
                      return _vm.changeModalTitle("loading")
                    },
                    initSuccess: function ($event) {
                      return _vm.changeModalTitle("success")
                    },
                    initError: function ($event) {
                      return _vm.changeModalTitle("error")
                    },
                    closeGlobalModal: _vm.closeModal,
                    priceRefresh: _vm.refreshPrice,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { class: { "chart-box": true, active: _vm.openChart } }, [
        _c("div", { staticClass: "header" }, [
          _vm.fromToken !== null &&
          _vm.toToken !== null &&
          _vm.pairData !== null
            ? _c("div", { staticClass: "left-area" }, [
                _c(
                  "div",
                  { staticClass: "icons" },
                  [
                    _c("nuxt-img", {
                      attrs: {
                        src:
                          _vm.fromToken.address !== _vm.$config.ZERO
                            ? _vm.$getImageByAddress(_vm.fromToken.address)
                            : _vm.$getImage(_vm.fromToken.logoURI),
                        alt: _vm.fromToken.name,
                        title: _vm.fromToken.symbol,
                        placeholder: "",
                        lazy: true,
                      },
                      on: {
                        error: function ($event) {
                          $event.target.src = require("~/static/img/default_token.svg")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("nuxt-img", {
                      attrs: {
                        src:
                          _vm.toToken.address !== _vm.$config.ZERO
                            ? _vm.$getImageByAddress(_vm.toToken.address)
                            : _vm.$getImage(_vm.toToken.logoURI),
                        alt: _vm.toToken.name,
                        title: _vm.toToken.symbol,
                        placeholder: "",
                        lazy: true,
                      },
                      on: {
                        error: function ($event) {
                          $event.target.src = require("~/static/img/default_token.svg")
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c("p", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.fromToken.symbol) +
                        "/" +
                        _vm._s(_vm.toToken.symbol) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "icon-area" }, [_c("Swap")], 1),
              ])
            : _c("div", { staticClass: "left-area" }, [
                _c(
                  "div",
                  { staticClass: "icons" },
                  [
                    _c("Skeleton", {
                      staticStyle: { "margin-right": ".25rem" },
                      attrs: { circle: "", width: "24px", height: "24px" },
                    }),
                    _vm._v(" "),
                    _c("Skeleton", {
                      attrs: { circle: "", width: "24px", height: "24px" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [
                  _c(
                    "p",
                    [
                      _c("Skeleton", {
                        attrs: { width: "75px", height: "25px" },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "right-area" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "details" }, [
          _vm.pairData !== null
            ? _c("div", { staticClass: "left-area" }, [
                _c("div", { staticClass: "price" }, [
                  _c("div", { staticClass: "h2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.lineChart !== null
                            ? _vm.lineChart.data.datasets[0].data[6]
                            : "0.00"
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.fromToken !== null && _vm.toToken !== null
                    ? _c("div", { staticClass: "h4" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.fromToken.symbol) +
                            "/" +
                            _vm._s(_vm.toToken.symbol) +
                            "\n          "
                        ),
                      ])
                    : _c("div", { staticClass: "h4" }, [
                        _vm._v("\n            .../...\n          "),
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "h4 plus" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.lineChart !== null
                            ? "+0.590 (0.73%)"
                            : "~0.00 (0.00%)"
                        ) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "date" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$beautifyDate("2023-01-12 08:00:00", true)) +
                      "\n        "
                  ),
                ]),
              ])
            : _c("div", { staticClass: "left-area" }, [
                _c("div", { staticClass: "price" }, [
                  _c(
                    "div",
                    { staticClass: "h2" },
                    [
                      _c("Skeleton", {
                        attrs: { width: "75px", height: "35px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "h4" },
                    [
                      _c("Skeleton", {
                        attrs: { width: "175px", height: "22px" },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "date" },
                  [
                    _c("Skeleton", {
                      attrs: { width: "130px", height: "16px" },
                    }),
                  ],
                  1
                ),
              ]),
          _vm._v(" "),
          _vm.pairData !== null
            ? _c("div", { staticClass: "right-area" }, [
                _c("div", { staticClass: "date-pips" }, [
                  _c(
                    "div",
                    {
                      class: { pip: true, active: _vm.dateFilter === 1 },
                      on: {
                        click: function ($event) {
                          return _vm.setDateFilter(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            24" +
                          _vm._s(_vm.$t("common.h")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { pip: true, active: _vm.dateFilter === 7 },
                      on: {
                        click: function ($event) {
                          return _vm.setDateFilter(7)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            1" +
                          _vm._s(_vm.$t("common.w")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { pip: true, active: _vm.dateFilter === 30 },
                      on: {
                        click: function ($event) {
                          return _vm.setDateFilter(30)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            1" +
                          _vm._s(_vm.$t("common.m")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { pip: true, active: _vm.dateFilter === 365 },
                      on: {
                        click: function ($event) {
                          return _vm.setDateFilter(365)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            1" +
                          _vm._s(_vm.$t("common.y")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ])
            : _c("div", { staticClass: "right-area" }, [
                _c(
                  "div",
                  { staticClass: "date-pips" },
                  [
                    _c("Skeleton", {
                      attrs: { width: "200px", height: "32px" },
                    }),
                  ],
                  1
                ),
              ]),
        ]),
        _vm._v(" "),
        _vm.pairData !== null && _vm.lineChart !== null && !_vm.loadingChart
          ? _c(
              "div",
              { staticClass: "chart-container" },
              [
                _c("LineChart", {
                  ref: "chart",
                  attrs: {
                    "chart-data": _vm.lineChart.data,
                    options: _vm.lineChart.options,
                  },
                }),
              ],
              1
            )
          : _vm.loadingChart || _vm.pairData === null
          ? _c(
              "div",
              { staticClass: "chart-container" },
              [
                _c("Loading"),
                _vm._v(" "),
                _c("div", { staticClass: "h6" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("analytics.loading_chart_data")) +
                      "\n      "
                  ),
                ]),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "chart-container" },
              [
                _c("CloudRefreshIcon"),
                _vm._v(" "),
                _c("div", { staticClass: "h6" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("analytics.no_chart_data")) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c("div", { class: { "swap-box": true, shorten: _vm.openChart } }, [
        _c("div", { staticClass: "header-area" }, [
          _c("h1", [
            _vm._v("\n        " + _vm._s(_vm.$t("swap.h1")) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { ref: "settingsButton", staticClass: "settings" }, [
            _c(
              "div",
              {
                class: { "toggler static": true, active: _vm.openChart },
                on: { click: _vm.toggleChart },
              },
              [_c("ChartApr")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toggler", on: { click: _vm.toggleSettings } },
              [_c("Cog")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tokens-area" }, [
          _c(
            "div",
            { staticClass: "token-item" },
            [
              _c("div", { staticClass: "form-area" }, [
                _c("div", { staticClass: "input-area" }, [
                  _c("label", { attrs: { for: "inputFrom" } }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("swap.from")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.swap.from_value,
                        expression: "swap.from_value",
                      },
                    ],
                    attrs: {
                      id: "inputFrom",
                      type: "number",
                      min: "0",
                      step: "0.0001",
                      lang: "en",
                      placeholder: "0.0...",
                    },
                    domProps: { value: _vm.swap.from_value },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.swap, "from_value", $event.target.value)
                        },
                        _vm.inputFrom,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "max-button": true,
                        active:
                          _vm.swap.from_token.balance !== undefined &&
                          parseFloat(_vm.swap.from_token.balance) > 0,
                      },
                      on: { click: _vm.setFromMax },
                    },
                    [
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("swap.max")) +
                            "\n              "
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "fromListButton",
                    staticClass: "token-select",
                    on: { click: _vm.toggleFromList },
                  },
                  [
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("liquidity.select_token")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.fromToken === null
                      ? _c("div", { staticClass: "token-data" }, [
                          _c("div", { staticClass: "token-area" }, [
                            _c("div", { staticClass: "empty-area" }),
                            _vm._v(" "),
                            _c("p", { staticClass: "normal" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("swap.pick")) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chevron-area" },
                            [_c("ChevronDown")],
                            1
                          ),
                        ])
                      : _c("div", { staticClass: "token-data" }, [
                          _c(
                            "div",
                            { staticClass: "token-area" },
                            [
                              _c("nuxt-img", {
                                attrs: {
                                  src:
                                    _vm.fromToken.address !== _vm.$config.ZERO
                                      ? _vm.$getImageByAddress(
                                          _vm.fromToken.address
                                        )
                                      : _vm.$getImage(_vm.fromToken.logoURI),
                                  alt: _vm.fromToken.name,
                                  title: _vm.fromToken.symbol,
                                  placeholder: "",
                                  lazy: true,
                                },
                                on: {
                                  error: function ($event) {
                                    $event.target.src = require("~/static/img/default_token.svg")
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.fromToken.symbol) +
                                    "\n                "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chevron-area" },
                            [_c("ChevronDown")],
                            1
                          ),
                        ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { ref: "fromList", staticClass: "token-select-list" },
                [
                  _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("swap.select_token")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    { staticClass: "search-area", attrs: { method: "POST" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "search-button",
                          attrs: {
                            type: "button",
                            "arira-label": _vm.$t("common.search"),
                          },
                        },
                        [_c("Search")],
                        1
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("common.search") + "...",
                        },
                        domProps: { value: _vm.search },
                        on: {
                          change: _vm.toggleTokensList,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.search = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "client-only",
                    [
                      _c("TokensList", {
                        attrs: {
                          "current-token": _vm.swap.from_token,
                          "pair-token": _vm.swap.to_token,
                          list: _vm.computedList,
                        },
                        on: { pick: _vm.selectFromToken },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "manageFromButton",
                      staticClass: "open-manage",
                      on: { click: _vm.toggleManageFrom },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("swap.manage")) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("ManageModal", {
                ref: "manageFromArea",
                attrs: { active: _vm.activeManageFrom },
                on: { toggle: _vm.toggleManageFrom },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "copy-area": true,
                    active:
                      _vm.swap.from_token.address.length > 0 &&
                      _vm.swap.from_token.address !== _vm.$config.ZERO,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "svg-area",
                      attrs: { tooltip: _vm.$t("common.copy") },
                      on: {
                        click: function ($event) {
                          return _vm.copyAddress(
                            $event,
                            _vm.swap.from_token.address
                          )
                        },
                      },
                    },
                    [_c("Copy")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "svg-area",
                      attrs: { tooltip: _vm.$t("common.add_to_metamask") },
                      on: {
                        click: function ($event) {
                          return _vm.$addToMetamask(_vm.swap.from_token)
                        },
                      },
                    },
                    [_c("MetamaskIcon")],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.fromToken !== null && _vm.fromToken.address.length > 0
                ? _c("p", { staticClass: "available" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("swap.available")) +
                        ":\n          "
                    ),
                    _vm.fromToken.balance !== undefined &&
                    _vm.fromToken.balance !== null
                      ? _c("span", { staticClass: "bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$formatCryptoAmount(_vm.fromToken.balance, 4)
                            )
                          ),
                        ])
                      : _c("span", { staticClass: "bold" }, [_vm._v("0")]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "swap-area" }, [
            _c(
              "div",
              { staticClass: "swap-button", on: { click: _vm.swapInputs } },
              [_c("Swap")],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "token-item" },
            [
              _c("div", { staticClass: "form-area" }, [
                _c("div", { staticClass: "input-area" }, [
                  _c("label", { attrs: { for: "inputTo" } }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("swap.to")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.swap.to_value,
                        expression: "swap.to_value",
                      },
                    ],
                    attrs: {
                      id: "inputTo",
                      type: "number",
                      min: "0",
                      step: "0.0001",
                      lang: "en",
                      placeholder: "0.0...",
                    },
                    domProps: { value: _vm.swap.to_value },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.swap, "to_value", $event.target.value)
                        },
                        _vm.inputTo,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "max-button": true,
                        active:
                          _vm.swap.to_token.balance !== undefined &&
                          parseFloat(_vm.swap.to_token.balance) > 0,
                      },
                      on: { click: _vm.setToMax },
                    },
                    [
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("swap.max")) +
                            "\n              "
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "toListButton",
                    staticClass: "token-select",
                    on: { click: _vm.toggleToList },
                  },
                  [
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("liquidity.select_token")) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.toToken === null
                      ? _c("div", { staticClass: "token-data" }, [
                          _c("div", { staticClass: "token-area" }, [
                            _c("div", { staticClass: "empty-area" }),
                            _vm._v(" "),
                            _c("p", { staticClass: "normal" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("swap.pick")) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chevron-area" },
                            [_c("ChevronDown")],
                            1
                          ),
                        ])
                      : _c("div", { staticClass: "token-data" }, [
                          _c(
                            "div",
                            { staticClass: "token-area" },
                            [
                              _c("nuxt-img", {
                                attrs: {
                                  src:
                                    _vm.toToken.address !== _vm.$config.ZERO
                                      ? _vm.$getImageByAddress(
                                          _vm.toToken.address
                                        )
                                      : _vm.$getImage(_vm.toToken.logoURI),
                                  alt: _vm.toToken.name,
                                  title: _vm.toToken.symbol,
                                  placeholder: "",
                                  lazy: true,
                                },
                                on: {
                                  error: function ($event) {
                                    $event.target.src = require("~/static/img/default_token.svg")
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.toToken.symbol) +
                                    "\n                "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "chevron-area" },
                            [_c("ChevronDown")],
                            1
                          ),
                        ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { ref: "toList", staticClass: "token-select-list" },
                [
                  _c("div", { staticClass: "h4" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("swap.select_token")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    { staticClass: "search-area", attrs: { method: "POST" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "search-button",
                          attrs: {
                            type: "button",
                            "arira-label": _vm.$t("common.search"),
                          },
                        },
                        [_c("Search")],
                        1
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search",
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("common.search") + "...",
                        },
                        domProps: { value: _vm.search },
                        on: {
                          change: _vm.toggleTokensList,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.search = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "client-only",
                    [
                      _c("TokensList", {
                        attrs: {
                          "current-token": _vm.swap.to_token,
                          "pair-token": _vm.swap.to_token,
                          list: _vm.computedList,
                        },
                        on: { pick: _vm.selectToToken },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "manageToButton",
                      staticClass: "open-manage",
                      on: { click: _vm.toggleManageTo },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("swap.manage")) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("ManageModal", {
                ref: "manageToArea",
                attrs: { active: _vm.activeManageTo },
                on: { toggle: _vm.toggleManageTo },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "copy-area": true,
                    active:
                      _vm.swap.to_token.address.length > 0 &&
                      _vm.swap.to_token.address !== _vm.$config.ZERO,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "svg-area",
                      on: {
                        click: function ($event) {
                          return _vm.copyAddress(
                            $event,
                            _vm.swap.to_token.address
                          )
                        },
                      },
                    },
                    [_c("Copy")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "svg-area",
                      on: {
                        click: function ($event) {
                          return _vm.$addToMetamask(_vm.swap.to_token)
                        },
                      },
                    },
                    [_c("MetamaskIcon")],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.toToken !== null && _vm.toToken.address.length > 0
                ? _c("p", { staticClass: "available" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("swap.available")) +
                        ":\n          "
                    ),
                    _vm.toToken.balance !== undefined &&
                    _vm.toToken.balance !== null
                      ? _c("span", { staticClass: "bold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$formatCryptoAmount(_vm.toToken.balance, 4)
                            )
                          ),
                        ])
                      : _c("span", { staticClass: "bold" }, [_vm._v("0")]),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tolerance" }, [
          _c("p", [
            _vm._v("\n        " + _vm._s(_vm.$t("swap.slippage")) + ": "),
            _c("span", [_vm._v(_vm._s(_vm.slippageTolerance))]),
            _vm._v("%\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: { "warning-area": true, active: _vm.errorText.length > 0 } },
          [
            _c("div", { staticClass: "icon-area" }, [_c("Warn")], 1),
            _vm._v(" "),
            _c("div", { staticClass: "text-area" }, [
              _vm._v("\n        " + _vm._s(_vm.errorText) + "\n      "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "buttons-area" }, [
          _vm.user !== undefined && _vm.user !== null
            ? _c(
                "button",
                {
                  class: {
                    "btn cyan": true,
                    disabled:
                      !_vm.tokensPicked ||
                      _vm.swapCtaDisabled ||
                      _vm.loading ||
                      _vm.swapInsufficient,
                  },
                  attrs: {
                    type: "button",
                    disabled:
                      !_vm.tokensPicked ||
                      _vm.swapCtaDisabled ||
                      _vm.loading ||
                      _vm.swapInsufficient,
                  },
                  on: { click: _vm.prepareSwap },
                },
                [
                  !_vm.loading
                    ? _c("span", [
                        _vm._v(
                          "\n          " + _vm._s(_vm.swapCta) + "\n        "
                        ),
                      ])
                    : _c("span", [_c("Loading")], 1),
                ]
              )
            : _c(
                "button",
                {
                  staticClass: "btn cyan",
                  on: { click: _vm.openConnectModal },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.connect_wallet")) +
                      "\n      "
                  ),
                ]
              ),
        ]),
        _vm._v(" "),
        !_vm.openChart
          ? _c("div", { staticClass: "coins-left" }, [
              _c(
                "picture",
                { staticClass: "picture" },
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/swap_coins-left.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "250",
                      src: "/img/new/swap_coins-left.webp",
                      alt: "Swap blockchain coins on Defi Pool Finance",
                      title: "Swap coins",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.openChart
          ? _c("div", { staticClass: "coins-right" }, [
              _c(
                "picture",
                { staticClass: "picture" },
                [
                  _c("source", {
                    attrs: {
                      srcset: "/img/new/swap_coins-right.webp",
                      type: "image/webp",
                    },
                  }),
                  _vm._v(" "),
                  _c("nuxt-img", {
                    attrs: {
                      fit: "inside",
                      width: "229",
                      src: "/img/new/swap_coins-right.webp",
                      alt: "Swap blockchain coins on Defi Pool Finance",
                      title: "Swap coins",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud" },
        [_c("CloudCyanLiquidityLeft")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cyan-cloud2" },
        [_c("CloudCyanLiquidityRight")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }